$(document).ready(function() {
	$('.btn-quest').on('click', function(e) {
		e.preventDefault();
		var $button = $(this);
		$.get($button.attr('href'), function(data) {
			data = $(data);
			$("#formModal22 .custom-form").html(data.find(".custom-form"));
			$('#formModal22').modal();
		});
		return false;
	}); 
	$("body").on("submit", "#formModal22 form", function(e) {
		var $form = $("#formModal22 form");
		$.ajax({
			type: "POST",
			url: $form.attr("action"),
			data: $form.serialize(), // serializes the form's elements.
			success: function(data) {
				data = $(data);
				if (data.find(".custom-form").html().length > 20) {
					$("#formModal22 .custom-form").html(data.find(".custom-form"));
				} else {

					$("#formModal22 .custom-form").html(data.find(".header-text"));

					setTimeout(function() {
						$('#formModal22').modal('hide');
					}, 6000);
				}
			}
		});

		e.preventDefault();
		return false;
	});
});